import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

interface MyRouterContext {
	queryClient: QueryClient;
	get_token: () => Promise<string | null>;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => <Outlet />,
});
